import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { transientState } from '@/integrations/Immersve/auth/TransientState';

export function useScrollRestore(): void {
  const router = useRouter();
  onMounted(async () => {
    await router.isReady();
    transientState.restoreScrollPosition();
  });
}
